export default __webpack_public_path__ + "static/media/sijil-emal.ad60f9d5.png";